import React, { useEffect, useState } from 'react';
import 'react-dropdown/style.css';
import { getCampaigns } from '../services/campaigns';
import { getVotes } from '../services/votes';
import { activateCampaign } from '../services/activateCampaign'
import './Admin.css';
import { Bar } from 'react-chartjs-2';
import { FaRedo, FaUserAlt, FaUserFriends, FaPowerOff, FaPlus } from 'react-icons/fa';
import { usePromiseTracker } from "react-promise-tracker";
import { Oval } from 'react-loading-icons'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useLocation, useHistory } from 'react-router-dom';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import { useAuth } from '../AuthContext/AuthContext'
import AdminCampana6 from './AdminCampana6';



export default function Admin() {
  const { dispatch } = useAuth();
  const [visible, setVisible] = useState(false);
  const [finalizada, setFinalizada] = useState(false);
  const [campana, setCampana] = useState("");
  const [IDcampana, setIDCampana] = useState(0);
  const [clase, setClase] = useState(0);
  const [campaigns, setCampaigns] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [votes, setVotes] = useState([]);
  const [selectedOption, setSelectedOption] = useState(campaigns[0]);
  const { promiseInProgress } = usePromiseTracker();
  const [dinamicTable, setdinamicTable] = useState([]);
  const [dinamicTableExtra, setdinamicTableExtra] = useState([]);
  const [segundo, setSegundo] = useState(0);
  const [minuto, setMinuto] = useState(0);
  const [hora, setHora] = useState(0);
  const [total, setTotal] = useState(0);
  let history = useHistory();
  const location = useLocation();

  let candidato = { Nombre: [], voto: [] };



  let data = {
    labels: candidates,
    datasets: [
      {
        label: campana,
        data: votes,
        backgroundColor: [
          'rgba(255, 99, 132, 0.5)',
          'rgba(54, 162, 235, 0.5)',
          'rgba(255, 206, 86, 0.5)',
          'rgba(75, 192, 192, 0.5)',
          'rgba(153, 102, 255, 0.5)',
          'rgba(255, 159, 64, 0.5)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };


  useEffect(() => {
    let mounted = true;
    getCampanas().then(response => {
      if (mounted) {
        setCampaigns(response.body);
      }
    });
    return () => mounted = false;
  }, [])

  function getCampanas() {
    return getCampaigns(-1, dispatch.token);
  }

  function reiniciar() {
    activateCampaign(IDcampana, 3, dispatch.token)
      .then(result => {
        if (result.body[0].valid === 'Allow') {
          getCampanas().then(response => {
            setCampaigns(response.body);
          });

          setVisible(false);
          setFinalizada(false);
          setCampana("");
          setIDCampana(0);
          setCampaigns([]);
          setCandidates([]);
          setSelectedOption(0);
        } else {
          NoReset();
        }
      });
  }

  function selectCandidate(campaign) {
    getVotes(campaign, dispatch.token)
      .then(result => {
        let subtotal = 0;
        for (var i = 0; i < result.body.length; i++) {
          candidato.Nombre.push(result.body[i].Nombre);
          candidato.voto.push(result.body[i].conteo);
          subtotal += result.body[i].conteo;
        }
        setTotal(subtotal);
        setdinamicTable(result.body);
        setdinamicTableExtra(result.extra);
        setSegundo(result.extra[0].segundo);
        setMinuto(result.extra[0].minuto);
        setHora(result.extra[0].hora);
        setVotes(candidato.voto);
        setCandidates(candidato.Nombre);
        if (campaign === "5" || campaign === "6") {
          localStorage.setItem('SegundaExtra', candidato.voto);
        }
      })
  }

  function selectCampana(campaign) {
    setCampana("");
    for (let i = 0; i < campaigns.length; i++) {
      if (parseInt(campaigns[i].IDCampana) === parseInt(campaign) && (parseInt(campaigns[i].Estado) === 1 || parseInt(campaigns[i].Estado) === 2)) {
        setCampana(campaigns[i].Nombre)
        selectCandidate(campaign);
        setVisible(true);
        setClase(campaigns[i].clase);
        if (parseInt(campaigns[i].Estado) === 2)
          setFinalizada(true);
        else
          setFinalizada(false);

        break;
      } else {
        setVisible(false);
      }

    }
  }
  const activarCampana = () => {
    activateCampaign(IDcampana, 1, dispatch.token)
      .then(result => {
        if (result.body[0].valid === 'Allow') {

          setHora(0);
          setMinuto(0);
          setSegundo(0);
          for (let i = 0; i < campaigns.length; i++) {
            if (parseInt(campaigns[i].IDCampana) === parseInt(IDcampana)) {
              campaigns[i].Estado = 1;
              selectCampana(IDcampana);
              setVisible(true);
              console.log("activa");
              break;
            } else {
              setVisible(false);
            }

          }
        }
      })
  }

  const finalizarCampana = () => {
    activateCampaign(IDcampana, 2, dispatch.token)
      .then(result => {
        if (result.body[0].valid === 'Allow') {
          for (let i = 0; i < campaigns.length; i++) {
            if (parseInt(campaigns[i].IDCampana) === parseInt(IDcampana)) {
              campaigns[i].Estado = 2;
              selectCampana(IDcampana);
              break;
            } else {
              setVisible(false);
            }

          }
        }
      })
  }

  const refrescar = () => {
    selectCandidate(IDcampana);
  }

  function handleChange(e) {
    if (!e) e = window.event;
    setSelectedOption(e.target.value);
    selectCampana(e.target.value);
    setIDCampana(e.target.value);
    setHora(0);
    setMinuto(0);
    setSegundo(0);
  }

  const NoReset = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>{"No se puede reiniciar la votación"}</h1>
            <div>
              <button
                className="button-modal"
                onClick={() => {
                  onClose();
                }}
              >
                Aceptar
              </button>
            </div>
          </div>
        );
      }
    });
  }

  const askForFinish = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>{"¿Desea finalizar el proceso?"}</h1>
            <div>
              <button className="no-botton button-modal no-botton" onClick={onClose}>No</button>
              <button
                className="button-modal"
                onClick={() => {
                  finalizarCampana();
                  onClose();
                }}
              >
                Si
              </button>
            </div>
          </div>
        );
      }
    });
  }

  const askForReset = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>{"¿Desea reiniciar la votación?"}</h1>
            <div>
              <button className="no-botton button-modal no-botton" onClick={onClose}>No</button>
              <button
                className="button-modal"
                onClick={() => {
                  reiniciar();
                  onClose();
                }}
              >
                Si
              </button>
            </div>
          </div>
        );
      }
    });
  }


  useEffect(() => {
    const interval = setInterval(() => {
      if (IDcampana !== 0 && finalizada === false) {
        selectCampana(IDcampana);

      }
    }, 30000);
    return () => clearInterval(interval);
  }, [IDcampana, finalizada, candidates, votes, campana]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!finalizada) {
        setSegundo(segundo + 1);
        if (segundo === 59) {
          setMinuto(minuto + 1);
          setSegundo(0);
        }
        if (minuto === 60) {
          setHora(hora + 1);
          setMinuto(0);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [segundo, minuto, hora, finalizada]);

  function Loggout() {
    localStorage.clear();
    history.push("/login");
  }

  function NewCampain() {
    history.push("/newcampana");
  }



  return (<div className="admin-wrapper">
    <div className='wrap header'>
      <div className='logoContainer'>
        <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo" alt="Guadalupana"></img>

      </div>
      {(location.pathname !== '/login' && location.pathname !== '/registro') ?
        <div>
          <button className={"button-small logout"} onClick={NewCampain}><FaPlus />  Votación </button>
          <button className={"button-small logout"} onClick={Loggout}><FaPowerOff />  Salir </button>
        </div> :
        <div></div>
      }
    </div>
    <h1 className="welcome_message"> {campana}</h1>
    {IDcampana === 0 ? (
      <div>
        <select className="Dropdown-control" value={selectedOption} onChange={(e) => handleChange(e)} defaultValue="0" disabled={promiseInProgress ? "disabled" : ""}>
          {campaigns.map((obj) => (
            <option key={obj.Nombre} value={obj.IDCampana}>
              {obj.Nombre}
            </option>
          ))}
          <option defaultValue value="0" disabled="disabled">
            {promiseInProgress ? "Cargando opciones..." : "Seleccione una opción"}
          </option>
        </select>


        {IDcampana === 0 && visible === false ? (
          <div></div>
        ) : (
          visible === true ?
            <button className="button refresh" onClick={refrescar} disabled={promiseInProgress ? "disabled" : ""}>
              <FaRedo />
            </button>
            :
            <div></div>
        )}
      </div>
    ) : (
      visible === false ? (
        <center>
          <div className='select-option-div'>
            <select className="Dropdown-control" value={selectedOption} onChange={(e) => handleChange(e)} defaultValue="0" disabled={promiseInProgress ? "disabled" : ""}>
              {campaigns.map((obj) => (
                <option key={obj.Nombre} value={obj.IDCampana}>
                  {obj.Nombre}
                </option>
              ))}
              <option defaultValue value="0" disabled="disabled">
                {promiseInProgress ? "Cargando opciones..." : "Seleccione una opción"}
              </option>
            </select>
          </div>
          <button className="button" onClick={activarCampana} disabled={promiseInProgress ? "disabled" : ""}>
            {promiseInProgress ? "Iniciando..." : "Iniciar votación"}
            {promiseInProgress && <Oval className="loading-icon" />}
          </button>
        </center>
      ) : (
        IDcampana === "11" ? (
          <AdminCampana6
            selectedOption={selectedOption}
            handleChange={handleChange}
            campaigns={campaigns}
            promiseInProgress={promiseInProgress}
            IDcampana={IDcampana}
            visible={visible}
            refrescar={refrescar}
            dinamicTableExtra={dinamicTableExtra}
            hora={hora}
            minuto={minuto}
            segundo={segundo}
            dinamicTable={dinamicTable}
            total={total}
            finalizada={finalizada}
            askForFinish={askForFinish}
            clase={clase}
            askForReset={askForReset}
          />
        ) : (
          <div className="dashboard">
            <center>
              <div className="div-table">
                <div className="div-table-row">
                  <div className="div-table-col grafica">
                    <Bar data={data} />
                  </div>
                  <div className="div-table-col tabla">
                    {dinamicTable.length > 0 ?
                      <div className="div-table">
                        <div className='select-option-div'>
                          <select className="Dropdown-control" value={selectedOption} onChange={(e) => handleChange(e)} defaultValue="0" disabled={promiseInProgress ? "disabled" : ""}>
                            {campaigns.map((obj) => (
                              <option key={obj.Nombre} value={obj.IDCampana}>
                                {obj.Nombre}
                              </option>
                            ))}
                            <option defaultValue value="0" disabled="disabled">
                              {promiseInProgress ? "Cargando opciones..." : "Seleccione una opción"}
                            </option>
                          </select>


                          {IDcampana === 0 && visible === false ? (
                            <div></div>
                          ) : (
                            visible === true ?
                              <button className="button refresh" onClick={refrescar} disabled={promiseInProgress ? "disabled" : ""}>
                                <FaRedo />
                              </button>
                              :
                              <div></div>
                          )}
                        </div>
                        {dinamicTableExtra.map(function (dinamicTableExtra, index) {
                          return (
                            <div className="div-table-row" key={index}>
                              <table className='tabla-conteos-izq'>
                                <tbody>
                                  <tr><td colSpan="2">Inscritos</td></tr>
                                  <tr><td><FaUserFriends /></td><td>{dinamicTableExtra.votantes}</td></tr>
                                </tbody>
                              </table>
                              <table className='tabla-conteos-der' >
                                <tbody>
                                  <tr><td colSpan="2">Votantes</td></tr>
                                  <tr><td><FaUserAlt /></td><td>{dinamicTableExtra.votos}</td></tr>
                                </tbody>
                              </table>

                              {/* IDcampana==="7"? (
                                              <table className='tabla-conteos-der' >
                                                  <tr><td colSpan="2">Asistentes</td></tr>
                                                  <tr><td><FaUserAlt/></td><td>{(localStorage.getItem('SegundaExtra'))}</td></tr>
                                              </table>
                                            ):(
                                              <div></div>
                                            )*/}
                              <div className='Cronometer'>{hora.toString().padStart(2, '0')}:{minuto.toString().padStart(2, '0')}:{segundo.toString().padStart(2, '0')}</div>
                            </div>)
                        })}
                        <br />
                        {IDcampana === "7" ? (
                          <div>
                            <div className="div-table-row" >
                              <div className="div-table-col candidate-name2 header-left"  > Candidato </div>
                              <div className="div-table-col candidate-vote2 header-rigth"  > Votos </div>
                              <div className="div-table-col candidate-vote2 header-rigth"  > % </div>
                            </div>
                            {dinamicTable
                              .map(function (dinamicTable, index) {
                                return (
                                  <div className="div-table-row" key={index}>
                                    <div className="div-table-col candidate-name2 like-td"  >{dinamicTable.Nombre}</div>
                                    <div className="div-table-col candidate-vote2 like-td"  >{dinamicTable.conteo}</div>
                                    <div className="div-table-col candidate-vote2 like-td"  >{total !== 0 ? ((dinamicTable.conteo / total * 100).toFixed(2)) : (0)}</div>
                                  </div>)
                              })}
                          </div>
                        ) : (
                          <div>
                            <div className="div-table-row" >
                              <div className="div-table-col candidate-name header-left"  > Candidato </div>
                              <div className="div-table-col candidate-vote header-rigth"  > Votos </div>
                            </div>
                            {dinamicTable
                              .map(function (dinamicTable, index) {
                                return (
                                  <div className="div-table-row" key={index}>
                                    <div className="div-table-col candidate-name like-td"  >{dinamicTable.Nombre}</div>
                                    <div className="div-table-col candidate-vote like-td"  >{dinamicTable.conteo}</div>
                                  </div>)
                              })}
                          </div>
                        )}

                        <center>
                          {finalizada}
                          <button className="button button-finalizacion"
                            disabled={finalizada ? "disabled" : ""}
                            onClick={askForFinish}  >
                            {promiseInProgress ? "Finalizando..." : "Finalizar"}
                            {promiseInProgress && <Oval className="loading-icon" />}
                          </button>
                          {clase === 3 && finalizada ? (
                            <button className="button button-finalizacion"
                              onClick={askForReset} >
                              {promiseInProgress ? "Reiniciar..." : "Reiniciar"}
                              {promiseInProgress && <Oval className="loading-icon" />}
                            </button>
                          ) : (
                            <div></div>
                          )

                          }

                        </center>
                      </div>
                      :
                      <div></div>
                    }
                  </div>
                </div>
              </div>
            </center>
          </div>
        )
      )
    )}
    <div>
    </div>
  </div>
  )
}